import axios from "axios";

export const publishDraft = async (id: string): Promise<void> => {
  await axios.post(`${window.configuration.apiUrl}api/faq/${id}/draft/publish`);
};
